/**
 * Pan temporário por barra de espaço (E37.F1.T01) — padrão de editor de
 * imagem: segurar espaço ativa o modo de mover a vista (prioridade sobre
 * régua/desenho enquanto pressionado); soltar devolve a ferramenta corrente.
 *
 * O estado vive em um hook único do modo Comparar (os dois painéis K e Q
 * compartilham a mesma tecla). Guard de alvos interativos: espaço em
 * input/botão focado continua digitando/ativando (mesmo guard do
 * OverlapViewport, que já implementa este gesto na mesa Sobrepor & alinhar).
 * `blur` da janela solta o pan (alt-tab com espaço pressionado não prende o
 * modo).
 */
import { useEffect, useState } from 'react';
import { isInteractiveTarget } from '@/lib/keyboard_guards';

export function useSpacePan(): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => {
    function onKey(event: KeyboardEvent): void {
      if (event.code !== 'Space') return;
      if (isInteractiveTarget(event.target)) return;
      event.preventDefault();
      setActive(event.type === 'keydown');
    }
    function onBlur(): void {
      setActive(false);
    }
    window.addEventListener('keydown', onKey);
    window.addEventListener('keyup', onKey);
    window.addEventListener('blur', onBlur);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('keyup', onKey);
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  return active;
}
